// Product ID to single Variant ID mapping
let tangent_selected_product_map;
let recommendIDfetch = false;
let tangent_selfie_id;
let default_addToCartText = "Add To Cart";
let default_addedToCartText = "Added to Cart!";
let default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_quiz_tags=[];

const section_basics_container = document.getElementById("section_basics_sub_container");
const section_essentials_container = document.querySelector("#section_essentials_sub_container");
const section_works_container = document.querySelector("#section_works_sub_container");

const tangent_client_domain_url = window.location.origin;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_basics:"Basic",
  section_essentials:"Essentials",
  section_works:"Works"
}

// Add default image url here
const tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

let tangent_client_domain_currency;
const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

let isPageLoadCalled = false;

// Use DOMContentLoaded to catch early loading
document.addEventListener("DOMContentLoaded", onLoadFunction);

// Use window.onload to catch full page load (if needed)
window.addEventListener("load", onLoadFunction);

function onLoadFunction(){
  if (!isPageLoadCalled) {
    isPageLoadCalled = true;
    const tangent_response_id = getClientResponseId();
    if (tangent_response_id != null) {
      const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
      doApiCall(checkout_url); 
    }
  }
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function doApiCall(url){
    fetch(url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function checkoutDataProcess(response){
    let tangent_recommended_products = response.products;
    let selected_variants_map = response.selected_variants;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText+" "; 
    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);

    createTabButtons();
  
    // Initial Tab setting
    setTabOpen(response.tags);
    tangent_quiz_tags = response.tags;
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
  
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
  
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, selected_variants_map);
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
      setElementDisplayById('tangent-general-text','block');
    }

    setupTabs();
}

// Utility function to scroll to a tab
const scrollToTab = (tabsContainer, tabButton) => {
    const position = tabButton.getBoundingClientRect();
    const scroll = tabsContainer.scrollLeft;
    tabsContainer.scrollTo({
        left: scroll + position.left - tabsContainer.offsetLeft - 30,
        behavior: 'smooth',
    });
};

// Utility function to hide all content divs
const hideAllTabContents = () => {
    document.querySelectorAll('.tabcontent').forEach(div => {
        div.style.display = 'none';
    });
};

// Utility function to show the corresponding content
const showTabContent = (tabButton) => {
    const targetDiv = document.querySelector(`#${tabButton.name}_container`);
    if (targetDiv) {
        targetDiv.style.display = 'block';
    }
};

// Utility function to update active class
const updateActiveTab = (tabButtons, activeButton) => {
    tabButtons.forEach(button => button.classList.remove('active'));
    activeButton.classList.add('active');
};

// Main logic for setting up tabs behaviour
const setupTabs = () => {
    const tabsContainer = document.querySelector('.tab');
    const tabButtons = document.querySelectorAll('.tab button');

    tabButtons.forEach(tabButton => {
        tabButton.addEventListener('click', function () {
            // Scroll to the clicked tab
            scrollToTab(tabsContainer, this);

            // Hide all content divs and show the corresponding content
            hideAllTabContents();
            showTabContent(this);

            // Update active class for the tabs
            updateActiveTab(tabButtons, this);
        });
    });
};

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    if (section !== "section_basics" && section !== "section_essentials" && section !== "section_works") {
      let product_section_grid = document.getElementById(section + "_product_grid");
    
      if (product_section_grid) {
        let product_fragment = document.createDocumentFragment(); 
        
        product_ids.forEach(id => {
          const product = products.find(p => String(p.id) === id);
          const product_html = getProductHTML(product, products.indexOf(product), section, selected_variants);
          
          if (product_html) {
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = product_html;
            product_fragment.appendChild(tempDiv.firstElementChild);
          }
        });
    
        product_section_grid.appendChild(product_fragment); // Append all at once
      }
    }

  });
}

function getVariant(product, variant_id){
  let variant_list = product.variants;
  for (let index = 0; index < variant_list.length; index++) {
    if(variant_list[index].id==variant_id){
      return variant_list[index];
    }
  }
  return null;
}

function getProductHTML(product, index, section, selected_variants) {
  
  let variant = getVariantOfProduct(product, selected_variants);
  if(variant && isProductAvailable(product, variant)){
    tangent_selected_product_map[product.id] = variant.id;
    // Destructuring for clarity
    const { price: productPrice, id: variantId, title: variantTitle, image_id: variantImageId } = variant;
    const { handle: productHandle, title: productTitle } = product;
    
    // Set URLs and image
    const variantImageUrl = getVariantImage(variantImageId, product);
    const variantProductUrl = `${tangent_client_domain_url}/products/${productHandle}?variant=${variantId}`;
  
    let variantLabel = "";
    // Determine if variant title is shown
    if(variantTitle!="Default Title"){
      variantLabel = `${variantTitle}`;
    }

    updateSectionAllToCartLink(section, variant);
    
    // Product HTML using template literals
    return `
      <div class="tangent-product-item">
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
          <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent-product-image" alt="${productTitle}">
          <p class="tangent-product-title tangent-product-title-text">
            <b>${productTitle}</b>
          </p>
          <p class="variant-title">${variantLabel}</p>
          <p id="price_tangent_product_${index}" class="tangent-product-price-text">
            ${tangent_client_domain_currency}${productPrice}
          </p>
        </a>
        <div id="${section}_variant_${index}" class="tangent-product-variant"></div>
        <p class="tangent-btn-add tangent-add-to-cart-button" id="${section}_cart_tangent_product_${index}_text">
          <a class="tangent-product-add-btn-wrapper" id="${variantId}" href="javascript:void(0)">
            ${default_addToCartText}
          </a>
        </p>
      </div>
    `;
  }
  else{
    return null;
  }
}

function getVariantOfProduct(product, selected_variants){
  const products_variant_list = selected_variants[product.id] || [];
  const hasSelectedVariants = products_variant_list.length > 0;
  
  let enable_variant_title = false;
  if(hasSelectedVariants){
    enable_variant_title = true;
    variant = getVariant(product, hasSelectedVariants[0]);
  }
  else{
    variant = product.variants[0];
  }
  
  return variant;
}

function isProductAvailable(product, variant) {
  // Check if the product is active
  if (product.status !== "active") {
    return false;
  }

  return variant.available_for_sale;
}

function setTabOpen(tags) {
  const tabWrapper = document.querySelector("#tab-wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");

  // Show tab wrapper
  tabWrapper.style.display = "block";

  // Determine the default tab index based on tags
  let tabIndex = 0;
  if (tags.includes("routine_10_mins") || tags.includes("routine_15_mins")) {
    tabIndex = 1;
  }

  // Hide all tab content and remove 'active' class from all links
  tabContents.forEach(tab => tab.style.display = "none");
  tabLinks.forEach(link => link.classList.remove("active"));

  // Show the appropriate tab content and activate the corresponding tab link
  tabContents[tabIndex].style.display = "flex";
  tabLinks[tabIndex].classList.add("active");
}

function createTabButtons(){
  for (var section in tabs_title_mapping) {
   createTabButton(section)    
  }
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(section_name, variant){
  let variant_id = variant.id;
  addToCarMapFunction(section_name, variant_id);
  // const basic_list = ["section_basics_skin_type", "section_basics_skin_concern"];
  // const essential_list = ["section_essentials_skin_type", "section_essentials_skin_concern"];
  // const work_list = ["section_works_skin_type", "section_works_skin_concern"];
  
  // if (basic_list.includes(section_name)) {
  //   section = "section_basics";
  //   addToCarMapFunction(section_name, variant_id);
  // }
  
  // if (essential_list.includes(section_name)) {
  //   section = "section_essentials";
  //   addToCarMapFunction(section, variant_id);
  // }
}

function addToCarMapFunction(section, variant_id){
  if (sections_add_to_cart_map[section]) {
    const sectionData = sections_add_to_cart_map[section];
    if (!sectionData.list.includes(variant_id)) {
      sectionData.count++;
      sectionData.cart_link += `&id[]=${variant_id}`;
      sectionData.list.push(variant_id);
    }
    
  } else {
    sections_add_to_cart_map[section] = {
      count: 1,
      cart_link: `${tangent_client_domain_url}/cart/add?id[]=${variant_id}`,
      list: [variant_id],
    };
  }  
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
// Custom function - Adding meta properties to add to cart function call
function addToCart(btn){ 
  const variantArray = Object.values(tangent_selected_product_map);
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if(btn!=undefined){
      btn.innerHTML = default_addedToCartText;
      btn.classList.add("added-to-cart-style"); 
    }    
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {

    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");
    add_all_to_cart_p_tag.setAttribute('data-sectionName', section_name);
  
    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;
  
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
  
    return add_all_to_cart_p_tag;
  }

// Custom function - Adding meta properties to add to cart function call
function addAllToCartFunction(button){
  let sectionName = button.getAttribute("data-sectionName");
  let productData = getProductData(sectionName);
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(productData)
  })
  .then(response => {
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function getProductData(sectionName){
  const sectionVariantList= sections_add_to_cart_map[sectionName].list;
  const allVariantList = Object.values(tangent_selected_product_map);
  let productData = {
   'items': []
  };
  for (let variantId of sectionVariantList) {
    let item = {
      'id': variantId,
      'quantity': 1
    }
    productData.items.push(item);
  }
  return productData;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    const basic_list = ["section_basics_skin_type", "section_basics_skin_concern"];
    const essential_list = ["section_essentials_skin_type", "section_essentials_skin_concern"];
    const work_list = ["section_works_skin_type", "section_works_skin_concern"];
    for (const section_name in product_sections) {
      if(section_name!="section_basics" && section_name!="section_essentials" && section_name!="section_works"){
        // The created container will have both a container to show text and products
        var section_container = createSectionContainer(section_name);    
        
        // Creating text sections before products sections if exists
        if(text_sections!=undefined){
           section_container = createTextSectionBeforeProducts(text_sections,section_container,section_name);
        }    
        // Creating section to add all products
        section_container.appendChild(addSectionProductGridContainer(section_name));
        
        let addAllToCart = createSectionAddAllToCart(section_name);
        section_container.appendChild(addAllToCart);
        
        if (basic_list.includes(section_name)) {
          section_basics_container.appendChild(section_container);
        }
        
        if (essential_list.includes(section_name)) {
          section_essentials_container.appendChild(section_container);
        }
        
        if (work_list.includes(section_name)) {
          section_works_container.appendChild(section_container);
        }
      }
        // let addAllToCart = createSectionAddAllToCart(section_name);
        
        // if(section_name=="section_basics"){
        //   document.getElementById("section_basics_container").appendChild(addAllToCart);
        // }
        // else if(section_name=="section_essentials"){
        //   document.getElementById("section_essentials_container").appendChild(addAllToCart); 
        // }
        // else if(section_name=="section_works"){
        //   document.getElementById("section_works_container").appendChild(addAllToCart); 
        // }
        // else{
          
        // }
      
    }
}

function cloneAndAppend(container, prefix, targetContainer) {
    let clonedContainer = container.cloneNode(true);
    let targetChild = clonedContainer.children[1] || clonedContainer.children[0];

    if (targetChild) {
        targetChild.id = `${prefix}_${targetChild.id}`;
        targetContainer.appendChild(clonedContainer);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
    return section_container;
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent'); 
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

const setElementDisplayById = (elementId, displayStyle) => {
  const element = document.getElementById(elementId);
  if (element) {
      element.style.display = displayStyle;
  }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  if(response.selfie_url!=undefined && response.selfie_url!=null){
    
    const canvasImg = document.querySelector('#selfie_image');
    setElementDisplayById('selfie_image','block');
    setSelfieId(response["selfie_id"]);
    if (canvasImg) {
        canvasImg.src = response.selfie_url;
    }
  }
  else{
    if(tangent_default_selfie_image_url!=""){
      if (canvasImg) {
        canvasImg.src = tangent_default_selfie_image_url;
      }
    }
    else{
      setElementDisplayById("tangent_selfie_container","none");
    }
  }
  setElementDisplayById('image-loading-section','none');
}

// Enabling button listeners
function enableButtonListener() {
  // Listener for "Add to Cart" buttons
  const allBtns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
  
  allBtns.forEach(button => {
    button.addEventListener('click', function(event) {
      addToCart(this);
    }, false);
  });

  // Listener for "Add to Cart" buttons
  const allCartBtns = document.querySelectorAll('.section_add_all_to_cart');
  
  allCartBtns.forEach(button => {
    button.addEventListener('click', function(event) {
      addAllToCartFunction(this);
    }, false);
  });
}

const loadElementsOnResponseData = () => {
    const allElements = document.querySelectorAll('.load-on-data');
    allElements.forEach(element => {
        element.style.display = "block";
    });
};
